import { getParams } from '../../util/getparms.es6';

export default class Music {
    constructor() {
        this.modal = document.querySelector('.c-musicmodal');
        this.modal_cd = document.querySelector('.c-musicmodal_cd');
        this.ajaxcontainer = document.querySelector('.c-musicmodal__ajaxcontainer');
        this.ajaxcontainer_cd = document.querySelector('.c-musicmodal_cd__ajaxcontainer');
        this.player = null;
        this.init();
    }

    init() {
        if (this.modal) {
            this.ytjtsetup();
            this.eventBind();
            this.onLoad();
        }
    }

    resetEvent() {
        this.eventBind('reset');
    }

    ytjtsetup() {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    ytsetup(id) {
        const changebtns = document.querySelectorAll('.js-music_change');
        let videoID = null;
        let setted = false;

        if (id) {
            videoID = id;
            changebtns.forEach((el) => {
                if (el.getAttribute('data-videoid') === id) {
                    el.classList.add('-active');
                }
            });
        } else {
            changebtns.forEach((el, index) => {
                if (index === 0) {
                    videoID = el.getAttribute('data-videoid');
                    el.classList.add('-active');
                }
            });
        }

        const _this = this;
        window.YT.ready(function () {
            _this.player = new YT.Player('musicplayer', {
                height: '360',
                width: '640',
                videoId: videoID,
                events: {
                    onStateChange: _this.onStateChange.bind(_this),
                    onError: _this.onError,
                },
            });
        });

        //キャプション初期設定
        this.setCaption(videoID);

        //DLSTリンク初期設定
        this.setDlst(videoID);
    }

    onError(e) {
        console.log(e);
    }

    onStateChange(e) {
        //プレミア公開も考慮してバッファリング(3)のタイミングに変更。そしてsetTimeoutさせる。
        if (e.data === 3) {
            setTimeout(() => {
                document.querySelector('.c-modal_movie__iframewrap').style.opacity = 1;
            }, 200);
        }
    }

    onLoad() {
        if (getParams('music_open')) {
            const tgt = document.querySelector(".c-musicmodal[data-modalid='music']");

            tgt && tgt.classList.add('-active');
            document.body.classList.add('-lock');

            const type = getParams('type') || 'unit';
            const id = getParams('id') || 'protostar';
            const videoid = getParams('videoid');

            const _this = this;

            const waitForYTAPI = (intervalMs, timeoutMs) => {
                const startTimeInMs = Date.now();

                const findLoop = () => {
                    if (window.onYouTubeIframeAPIReady) {
                        _this.setContent(type, id, videoid);
                        return;
                    } else {
                        setTimeout(() => {
                            if (timeoutMs && Date.now() - startTimeInMs > timeoutMs) return;
                            findLoop();
                        }, intervalMs);
                    }
                };

                findLoop();
            };

            waitForYTAPI(100, 10000);
        } else if (getParams('music_cd_open')) {
            const tgt = document.querySelector(".c-musicmodal[data-modalid='music_cd']");

            tgt && tgt.classList.add('-active');
            document.body.classList.add('-lock');

            const category = getParams('category') || 'uniteup';
            const index = getParams('index') || 1;

            const _this = this;

            const waitForYTAPI = (intervalMs, timeoutMs) => {
                const startTimeInMs = Date.now();

                const findLoop = () => {
                    if (window.onYouTubeIframeAPIReady) {
                        _this.setContentCd(category, index);
                        return;
                    } else {
                        setTimeout(() => {
                            if (timeoutMs && Date.now() - startTimeInMs > timeoutMs) return;
                            findLoop();
                        }, intervalMs);
                    }
                };

                findLoop();
            };

            waitForYTAPI(100, 10000);
        }
        //モーダルオープンのパラメータがあったら、モーダル起動
    }

    async setContent(type, id, videoid) {
        this.ajaxcontainer.innerHTML = '';
        const url = `/anime/2nd/_inc/common/modal/musicmodal_contents.html?type=${type}&id=${id}`;
        const result = await fetch(url, {
            method: 'GET',
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const message = doc.body.innerHTML;
                return message;
            });

        this.modal.setAttribute('data-type', type);
        this.ajaxcontainer.innerHTML = result;
        this.ytsetup(videoid);
        this.changeEventBind();
    }

    async setContentCd(category, index) {
        this.ajaxcontainer_cd.innerHTML = '';
        const url = `/anime/2nd/_inc/common/modal/musicmodal_cd_contents.html?category=${category}&index=${index}`;
        const result = await fetch(url, {
            method: 'GET',
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const message = doc.body.innerHTML;
                return message;
            });

        this.ajaxcontainer_cd.innerHTML = result;
        window.modal.resetEvent();
        window.movie.resetEvent();
        window.movie.resetEvent();
        window.expansion.resetEvent();
        window.movieslide.setSwiper();
        window.slide.setSwiper();
        window.accordion.resetEvent();
    }

    setCaption(id) {
        const wrapper = document.querySelector('.js-music_cap');
        const list = [...document.querySelectorAll('.js-music_change')];

        list.forEach((el) => {
            if (el.getAttribute('data-videoid') === id) {
                wrapper.textContent = el.getAttribute('data-cap');
            }
        });
    }

    setDlst(id) {
        const wrapper = document.querySelector('.js-music_dlst');
        const link = document.querySelector('.js-music_dlst a');
        const list = [...document.querySelectorAll('.js-music_change')];

        list.forEach((el) => {
            if (el.getAttribute('data-videoid') === id) {
                wrapper.classList.remove('-nodlst');
                link.setAttribute('href', el.getAttribute('data-dlst'));

                if (el.getAttribute('data-dlst') === '') {
                    wrapper.classList.add('-nodlst');
                }
            }
        });
    }

    changeEventBind() {
        const buttons = [...document.querySelectorAll('.js-music_change')];

        buttons.forEach((el) => {
            el.addEventListener('click', () => {
                buttons.forEach((el) => el.classList.remove('-active'));
                el.classList.add('-active');
                const id = el.getAttribute('data-videoid');
                this.player && this.player.loadVideoById({ videoId: id });
                this.setCaption(id);
                this.setDlst(id);
            });
        });
    }

    eventBind(resetOption) {
        const openbuttons = [...document.querySelectorAll('.js-music_open')];
        const closebuttons = [...document.querySelectorAll('.js-music_close')];
        const _this = this;

        const handleOpen = function (e) {
            e.preventDefault();

            if (this.el.getAttribute('data-modalid') === 'music_cd') {
                // cdモーダルの場合
                const category = this.el.getAttribute('data-category');
                const index = this.el.getAttribute('data-index');

                _this.setContentCd(category, index);
            } else {
                const type = this.el.getAttribute('data-type');
                const nameid = this.el.getAttribute('data-nameid');
                const videoid = this.el.getAttribute('data-videoid');

                _this.setContent(type, nameid, videoid);
            }
        };

        const handleClose = (e) => {
            this.player.destroy();
        };

        openbuttons.forEach((el) => {
            resetOption && el.removeEventListener('click', handleOpen);
            el.addEventListener('click', { el: el, handleEvent: handleOpen });
        });

        closebuttons.forEach((el) => {
            resetOption && el.removeEventListener('click', handleClose);
            el.addEventListener('click', handleClose);
        });
    }
}
